import { EMeetingUserType } from './zoom';

export enum EDocumentSortBy {
    UPLOAD_TIME = 'UPLOAD_TIME',
    MODIFY_TIME = 'MODIFY_TIME',
}

export enum EDocumentSortType {
    ASC = 'ASC',
    DESC = 'DESC',
}

export interface IGetDocumentListParams {
    clientId?: number;
    current?: number;
    klarityUserId?: number;
    name?: string;
    orderKey?: string;
    orderType?: string;
    size?: number;
    sortBy?: EDocumentSortBy;
    sortType?: EDocumentSortType;
    tags?: string[];
    uploadBySelf?: boolean;
    visibleProviderIds?: number[];
    visibleToPatient?: boolean;
}

// {
//     "id": 481,
//     "name": "test666",
//     "tag": [
//         "Identity & Eligibility",
//         "Consents & Legal"
//     ],
//     "note": "gggg",
//     "ownerType": "CLIENT",
//     "ownerId": 108106,
//     "documentUrl": "document/group/4100/identity/8204/93d0a776-2c47-44de-9162-ae074e419e4a.png",
//     "documentType": "",
//     "businessId": 0,
//     "businessType": "",
//     "visibleToPatient": false,
//     "visibleIdList": null,
//     "visibleList": null,
//     "createdByType": "ORG_STAFF",
//     "createdById": 8272,
//     "createdBy": null,
//     "uploaderRole": null,
//     "practiceName": null,
//     "createdAt": "2026-06-25T10:37:48",
//     "updatedAt": "2026-06-25T10:37:48",
//     "newFlag": null,
//     "newVersion": null,
//     "fileUploadId": 741,
//     "fileOriginName": "111.png",
//     "fileType": "image/png",
//     "provider": {
//         "providerId": 10006304,
//         "firstName": "0618-owner",
//         "lastName": "chen",
//         "avatar": "https://saas-dev-jp.s3.ap-northeast-1.amazonaws.com/test/765d0210-1a97-4dac-a8fe-2762b3b20e03.png"
//     }
// }

export interface IGetDocumentItem {
    businessId: number;
    businessType: string;
    createdAt: string;
    createdBy?: string;
    createdById: number;
    createdByType: EMeetingUserType;
    documentType: string;
    documentUrl: string;
    fileOriginName: string;
    fileUploadId: number;
    fileType: string;
    id: number;
    name: string;
    newFlag?: boolean;
    newVersion?: number;
    note: string;
    ownerId: number;
    ownerType: string;
    tag: string[];
    updatedAt: string;
    visibleList?: number[];
    visibleToPatient: boolean;
    provider?: {
        providerId: number;
        firstName: string;
        lastName: string;
        avatar: string;
    };
}

export interface IGetDocumentListResponse {
    list: IGetDocumentItem[];
    totalRecords: number;
    pageSize: number;
    pageNo: number;
    isLast: boolean;
}

export interface ISaveOrUpdateDocument {
    id?: number;
    name: string;
    tag: string[];
    fileUploadId?: number;
    note?: string;
    source?: string;
    visibleSubjectIds?: number[];
}

export interface DocumentUploadData {
    name: string;
    tag: string[];
    visibleToPatient: boolean;
    noteToPatient?: string;
    fileUploadId?: number;
}
